import React from "react"
import {FieldTableCellProps} from "../../../../../render/table/table-cell";
import {EntityType} from "../../../../../../gd/const/item";
import {isBulkSelection} from "../../../../../../gd/right-click-menu";

// const debug = "FieldItemModelCalculatedEstimate_TableCell"
const debug = false

type State = {
    isHovered   : boolean
    showPopover : boolean
}

export default class FieldItemModelCalculatedEstimate_TableCell extends React.Component<FieldTableCellProps, State> {

    constructor(props:FieldTableCellProps) {
        super(props)

        this.state = {
            isHovered   : false,
            showPopover : false
        }
    }

    get isEditable():boolean {
        switch (this.props.listItem.type) {

            case EntityType.TASK:
                return !this.props.manager.isReadOnly && this.props.listItem.task.acl.canChangeEstimate

            case EntityType.PROJECT:
                return !this.props.manager.isReadOnly && this.props.listItem.project.acl.canChangeEstimate

            default:
                return false
        }
    }

    onMouseEnter = () => {

        if (!this.isEditable) return

        if (!this.state.isHovered) this.setState({
            isHovered   : true
        })
    }

    onMouseLeave = () => {
// return
        if (this.state.showPopover) return //

        if (this.state.isHovered) this.setState({
            isHovered   : false
        })
    }

    onValueChange = (value:number|null, hidePopover:boolean=true) => {



        switch (this.props.listItem.type) {
            case EntityType.TASK:
                this.props.listItem.task.estimate = value
                this.props.listItem.task.save() // no await !
                break;

            case EntityType.PROJECT:
                this.props.listItem.project.estimate = value
                this.props.listItem.project.save() // no await !
                break

            case EntityType.EVENT:
            default:
                return
        }




        // need it because of calculated values
        this.props.manager.updateChildrenItems();

        hidePopover && this.hidePopover()

        debug && console.log(debug, "need rerender callback=", this.props.manager.listRenderCallback)

        this.props.manager.listRenderCallback && this.props.manager.listRenderCallback()
    }

    onDeleteClick = (e:React.MouseEvent) => {
        if (isBulkSelection(e)) return
        e.stopPropagation()
        this.onValueChange(null, false)
    }

    onClick = (e: React.MouseEvent) => {
        if (isBulkSelection(e)) return
        if (!this.isEditable) return

        this.setState({
            showPopover     : !this.state.showPopover
        })

    }

    hidePopover = () => {
        this.setState({
            showPopover     : false,
            isHovered       : false
        })
    }

    get style() {

        // this is common part for table cell
        // end common part

        const width = this.props.column.width ? this.props.column.width : this.props.manager.columnsManager.getColumnWidth(this.props.column)

        const style : style = _.clone(this.props.style) || {} // we need clone here because we add width!
        style.width = width

        return style
    }

    renderHovered() {

        const field         = this.props.field
        const classes       = Classes("cell-flex is-hovered ui5-txt-less-important-small")

        const showChildren  = this.props.listItem.isCollapsed && this.props.listItem.estimated.children>0

        return (
            <React.Fragment>
                <div className={classes} style={this.style} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave} >
                    <div className="ui5-field-editable size-small is-hovered w-100-percent h-100-percent" onClick={this.onClick}>

                        <div className="flex-row-left-center truncate">

                            {this.props.listItem.estimated.own>0 &&
                                <div className="ui5-txt-less-important-small">{gd.utils.minutesHumanize(this.props.listItem.estimated.own)}</div>
                            }

                            {!this.props.listItem.estimated.own && !showChildren && this.props.field.label}

                            {showChildren && this.props.listItem.estimated.own>0 &&
                                <div className="ui5-txt-less-important-small m-r-5 m-l-5">+</div>
                            }

                            {showChildren &&
                                <>
                                    <div className="ui5-ico-12 i5-folder-tree m-r-5 m-t-1"/>
                                    <div className="ui5-txt-less-important-small">{gd.utils.minutesHumanize(this.props.listItem.estimated.children)}</div>
                                </>
                            }

                            {this.state.showPopover &&
                                <field.components.PopoverMenu {...this.props} parent={this}/>
                            }

                        </div>

                        <div className="buttons">
                            {this.props.listItem.estimated.own>0 && <div className="btn-reset" onClick={this.onDeleteClick}/>}
                            <div className="btn-arrow"/>
                        </div>

                    </div>

                </div>
            </React.Fragment>
        )
    }

    renderNotHovered() {
        const classes = Classes("cell-flex ui5-field-editable size-small ui5-txt-less-important-small", this.props.column.id, {
            // 'is-hovered'        : this.state.isHovered
        })

        let notHoveredContent    = null
        let showSummary = false

        if (this.props.listItem.isCollapsed && this.props.listItem.estimated.total && this.props.listItem.estimated.total!=this.props.listItem.estimated.own) {
            notHoveredContent = this.props.listItem.estimated.total
            showSummary = true
        } else if (this.props.listItem.estimated.own) {
            notHoveredContent = this.props.listItem.estimated.own
        } else {
            // display nothing :)
        }

        return (
            <React.Fragment>
                <div className={classes} style={this.style} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
                    {showSummary && <div className="ui5-ico-12 i5-summary-symbol m-r-5"/>}
                    {!!notHoveredContent && gd.utils.minutesHumanize(notHoveredContent)}
                </div>
            </React.Fragment>
        )

    }

    render() {
        // debug && console.log(debug, "render()", this.props)
        debug && console.log(debug, "render() isHovered=", this.state.isHovered)

        if (this.state.isHovered) return this.renderHovered()
        else return this.renderNotHovered()

    }

}



